var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.icon && !!_vm.src)?_c('div',[(!!_vm.color)?_c('div',{style:(_vm.style)}):_c('img',{attrs:{"height":_vm.iconSize,"src":_vm.requiredSrc,"width":_vm.iconSize}})]):(!!_vm.icon && !!_vm.iconComponent)?_c(_vm.iconComponent,{tag:"component",attrs:{"icon":_vm.icon,"fill-color":_vm.resolvedColor}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }